export function isValidContactValue(val) {
  if (val == null) return false;
  const str = String(val).trim().toLowerCase();
  return (
    str !== '' &&
    str !== '-' &&
    str !== 'none' &&
    str !== 'null' &&
    str !== 'undefined'
  );
}

export function getContactChannelCapabilities(contact) {
  const emailVal =
    contact?.email ||
    contact?.from_email ||
    contact?.contact_email ||
    contact?.lead?.email ||
    contact?.raw?.email ||
    contact?.raw?.from_email;

  const phoneVal =
    contact?.phone ||
    contact?.phone_number ||
    contact?.mobile ||
    contact?.contact_phone ||
    contact?.lead?.phone ||
    contact?.raw?.phone;

  const hasEmail = isValidContactValue(emailVal);
  const hasPhone = isValidContactValue(phoneVal);

  return { hasEmail, hasPhone };
}
